import * as ng from 'angular';
import { StateService } from '@uirouter/angularjs';

export class ChangePasswordController {
   static $inject = ['$state', 'userApi', 'toast', 'session'];

   constructor(
      private $state:StateService,
      private userApi,
      private toast,
      private session)
   {
      this.newPassword = {
         id: this.session.getUser().id
      };
   }

   newPassword:{
      id:number,
      existingPassword?:string,
      password?:string,
      confirmPassword?:string
   };

   save() {
      this.userApi.changePassword(this.newPassword).then(() => {
         this.session.refreshUser();
         this.toast.success()
            .message('Your password has been successfully updated')
            .send();

         this.$state.go('profile');
      });
   }
}

ng.module('e360').controller('ChangePasswordController', ChangePasswordController);
